import { render, staticRenderFns } from "./eliminar-opcion.vue?vue&type=template&id=b0383b62&scoped=true&"
import script from "./eliminar-opcion.vue?vue&type=script&lang=js&"
export * from "./eliminar-opcion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0383b62",
  null
  
)

export default component.exports